/* tslint:disable */
/* eslint-disable */
/**
 * Onibi Portal Api
 * The API for the OnibiPortal Server project
 *
 * OpenAPI spec version: v1
 * Contact: info@yumebau.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * LocationsApi - axios parameter creator
 * @export
 */
export const LocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [locationDtoString] 
         * @param {string} [server] 
         * @param {boolean} [createDareStats] 
         * @param {string} [dareStatSeparator] 
         * @param {string} [dareStatNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsAddOrEditPostForm: async (inGameThumbnails?: Array<Blob>, locationDtoString?: string, server?: string, createDareStats?: boolean, dareStatSeparator?: string, dareStatNames?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Locations/addOrEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new FormData();

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (createDareStats !== undefined) {
                localVarQueryParameter['createDareStats'] = createDareStats;
            }

            if (dareStatSeparator !== undefined) {
                localVarQueryParameter['dareStatSeparator'] = dareStatSeparator;
            }

            if (dareStatNames !== undefined) {
                localVarQueryParameter['dareStatNames'] = dareStatNames;
            }

            if (inGameThumbnails) {
                inGameThumbnails.forEach((element) => {
                    localVarFormParams.append('InGameThumbnails', element as any);
                })
            }

            if (locationDtoString !== undefined) { 
                localVarFormParams.append('locationDtoString', locationDtoString as any);
            }

            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsDeleteIdDelete: async (id: string, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiLocationsDeleteIdDelete.');
            }
            const localVarPath = `/api/Locations/delete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [isPolygon] 
         * @param {string} [tagFilter] 
         * @param {string} [searchTerm] 
         * @param {string} [localizationLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsListGet: async (server?: string, page?: number, pageSize?: number, includeDeleted?: boolean, isPolygon?: boolean, tagFilter?: string, searchTerm?: string, localizationLanguage?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Locations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }

            if (isPolygon !== undefined) {
                localVarQueryParameter['isPolygon'] = isPolygon;
            }

            if (tagFilter !== undefined) {
                localVarQueryParameter['tagFilter'] = tagFilter;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (localizationLanguage !== undefined) {
                localVarQueryParameter['localizationLanguage'] = localizationLanguage;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLocationsUndeleteIdPut: async (id: string, server?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling apiLocationsUndeleteIdPut.');
            }
            const localVarPath = `/api/Locations/undelete/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (server !== undefined) {
                localVarQueryParameter['server'] = server;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocationsApi - functional programming interface
 * @export
 */
export const LocationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [locationDtoString] 
         * @param {string} [server] 
         * @param {boolean} [createDareStats] 
         * @param {string} [dareStatSeparator] 
         * @param {string} [dareStatNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsAddOrEditPostForm(inGameThumbnails?: Array<Blob>, locationDtoString?: string, server?: string, createDareStats?: boolean, dareStatSeparator?: string, dareStatNames?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await LocationsApiAxiosParamCreator(configuration).apiLocationsAddOrEditPostForm(inGameThumbnails, locationDtoString, server, createDareStats, dareStatSeparator, dareStatNames, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsDeleteIdDelete(id: string, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await LocationsApiAxiosParamCreator(configuration).apiLocationsDeleteIdDelete(id, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [isPolygon] 
         * @param {string} [tagFilter] 
         * @param {string} [searchTerm] 
         * @param {string} [localizationLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsListGet(server?: string, page?: number, pageSize?: number, includeDeleted?: boolean, isPolygon?: boolean, tagFilter?: string, searchTerm?: string, localizationLanguage?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await LocationsApiAxiosParamCreator(configuration).apiLocationsListGet(server, page, pageSize, includeDeleted, isPolygon, tagFilter, searchTerm, localizationLanguage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsUndeleteIdPut(id: string, server?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>> {
            const localVarAxiosArgs = await LocationsApiAxiosParamCreator(configuration).apiLocationsUndeleteIdPut(id, server, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LocationsApi - factory interface
 * @export
 */
export const LocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {Array<Blob>} [inGameThumbnails] 
         * @param {string} [locationDtoString] 
         * @param {string} [server] 
         * @param {boolean} [createDareStats] 
         * @param {string} [dareStatSeparator] 
         * @param {string} [dareStatNames] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsAddOrEditPostForm(inGameThumbnails?: Array<Blob>, locationDtoString?: string, server?: string, createDareStats?: boolean, dareStatSeparator?: string, dareStatNames?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return LocationsApiFp(configuration).apiLocationsAddOrEditPostForm(inGameThumbnails, locationDtoString, server, createDareStats, dareStatSeparator, dareStatNames, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsDeleteIdDelete(id: string, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return LocationsApiFp(configuration).apiLocationsDeleteIdDelete(id, server, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [server] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {boolean} [includeDeleted] 
         * @param {boolean} [isPolygon] 
         * @param {string} [tagFilter] 
         * @param {string} [searchTerm] 
         * @param {string} [localizationLanguage] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsListGet(server?: string, page?: number, pageSize?: number, includeDeleted?: boolean, isPolygon?: boolean, tagFilter?: string, searchTerm?: string, localizationLanguage?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return LocationsApiFp(configuration).apiLocationsListGet(server, page, pageSize, includeDeleted, isPolygon, tagFilter, searchTerm, localizationLanguage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [server] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLocationsUndeleteIdPut(id: string, server?: string, options?: AxiosRequestConfig): Promise<AxiosResponse<void>> {
            return LocationsApiFp(configuration).apiLocationsUndeleteIdPut(id, server, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
export class LocationsApi extends BaseAPI {
    /**
     * 
     * @param {Array<Blob>} [inGameThumbnails] 
     * @param {string} [locationDtoString] 
     * @param {string} [server] 
     * @param {boolean} [createDareStats] 
     * @param {string} [dareStatSeparator] 
     * @param {string} [dareStatNames] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public async apiLocationsAddOrEditPostForm(inGameThumbnails?: Array<Blob>, locationDtoString?: string, server?: string, createDareStats?: boolean, dareStatSeparator?: string, dareStatNames?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return LocationsApiFp(this.configuration).apiLocationsAddOrEditPostForm(inGameThumbnails, locationDtoString, server, createDareStats, dareStatSeparator, dareStatNames, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public async apiLocationsDeleteIdDelete(id: string, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return LocationsApiFp(this.configuration).apiLocationsDeleteIdDelete(id, server, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} [server] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {boolean} [includeDeleted] 
     * @param {boolean} [isPolygon] 
     * @param {string} [tagFilter] 
     * @param {string} [searchTerm] 
     * @param {string} [localizationLanguage] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public async apiLocationsListGet(server?: string, page?: number, pageSize?: number, includeDeleted?: boolean, isPolygon?: boolean, tagFilter?: string, searchTerm?: string, localizationLanguage?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return LocationsApiFp(this.configuration).apiLocationsListGet(server, page, pageSize, includeDeleted, isPolygon, tagFilter, searchTerm, localizationLanguage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {string} id 
     * @param {string} [server] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    public async apiLocationsUndeleteIdPut(id: string, server?: string, options?: AxiosRequestConfig) : Promise<AxiosResponse<void>> {
        return LocationsApiFp(this.configuration).apiLocationsUndeleteIdPut(id, server, options).then((request) => request(this.axios, this.basePath));
    }
}
